<template lang="pug">
  b-row
    b-col(sm='12')
      b-form(@submit.prevent='submit')
        b-card
          div(slot='header')
            strong {{ formName }}
            small.pl-2 Form

          b-row
            b-col(sm='6')
              b-col(sm='12')
                b-form-fieldset(label='Name')
                  b-form-input(
                    type='text'
                    id='project_name'
                    name="name"
                    placeholder="Enter project's name"
                    v-validate="'required'"
                    v-model='project.name'
                  )
                  div.text-danger(v-show="errors.has('name')") {{ errors.first('name') }}
              b-col(sm='12')
                b-form-fieldset(label="Type")
                  b-form-select(
                    :plain='true'
                    :options='typeOptions'
                    id='project_type'
                    name='type'
                    v-validate="'required'"
                    v-model='project.type'
                  )
                  div.text-danger(v-show="errors.has('type')") {{ errors.first('type') }}

              b-col(sm='12')
                b-form-fieldset.pb-0(v-if='!isEdit()' label='Customers')
                  small Enter here the customers who can view all objects
                  multiselect(
                    id='project_customers'
                    name='customers'
                    v-model='currentCustomers'
                    :multiple='true'
                    :options='customersList'
                    :loading='customerLoading'
                    :internal-search='false'
                    @search-change='asyncFindCustomers'
                    label='card_name'
                    :close-on-select='true'
                    track-by='id'
                    placeholder='Search a customer here'
                    v-validate="'required'"
                  )
                  div.text-danger(v-show="errors.has('customers')") {{ errors.first('customers') }}

            b-col(sm='6')
              b-col(sm='12')
                b-form-fieldset(v-if='!isEdit()' label='Objects')
                  multiselect(
                    id='project_structures'
                    name='structures'
                    v-model='currentStructures'
                    :multiple='true'
                    :options='structuresList'
                    :loading='structuresLoading'
                    :internal-search='false'
                    @search-change='asyncFindStructures'
                    label='card_name'
                    :close-on-select='true'
                    track-by='id'
                    placeholder='Search objects here'
                  )

          b-col.py-4(sm='12')
            button.btn.btn-primary.px-4(type='submit') Save
            button.btn.btn-primary.px-4.mx-2(
              v-if='!isEdit()'
              type='button'
              @click='saveGoToStructuresManagement()'
            ) Save and go to Objects Management
            button.btn.btn-primary.px-4.mx-2(
              v-if='isEdit()'
              type='button'
              @click='goToStructuresManagement()'
            ) Objects Management
</template>

<script>
  import server from '@/server'
  import Policeman from '@/utils/Policeman/policeman'
  import Messages from '@/utils/notificationsMsg'
  import Multiselect from 'vue-multiselect'
  import _ from 'lodash'
  import RouteGen from '@/utils/apiRoutes'
  import { options } from '@/utils/resourceNormalizer'

  export default {
    name: 'ProjectForm',
    components: { Multiselect },
    data () {
      return {
        typeOptions: options['project_type'],
        formName: 'Create a new Project',
        customerLoading: false,
        structuresLoading: false,
        customersList: [],
        structuresList: [],
        currentCustomers: '',
        currentStructures: [],
        project: {
          name: '',
          type: '',
          customer_ids: [],
          structure_ids: []
        }
      }
    },
    mounted () {
      if (this.isEdit()) {
        this.$set(this.$data, 'formName', "Modify project's informations")
        this.fetchProject(this.$route.params.id)
      }
    },
    methods: {
      isEdit () {
        return this.$route.params.hasOwnProperty('id')
      },
      getResourcesIds (resources) {
        if (resources) { return resources.map((resource) => { return resource.id }) }
      },
      fetchProject (projectId) {
        let currentPermissions = this.$route.meta.roles
        if (!Policeman.authorize(currentPermissions)) {
          this.showNotification(401)
          this.$route.push({ name: 'Home' })
        }
        let route = RouteGen.show('project', projectId)
        server.get(route)
          .then(res => {
            let project = res.data.project
            this.$set(this.$data.project, 'name', project.name)
            this.$set(this.$data.project, 'type', project.type)
            this.$set(this.$data.project, 'customer_id', project.customer.id)
            this.$set(this.$data, 'currentCustomers', project.customers)
            this.$set(this.$data.project, 'structure_ids', this.getResourcesIds(project.structures))
            this.$set(this.$data, 'currentStructures', project.structures)
          })
          .catch(err => {
            console.log(err)
          })
      },
      asyncFindCustomers: _.debounce(
        function (query) {
          this.customerLoading = true
          let url = RouteGen.index('user')
          server.get(url, {
            params: {
              'q[role_eq]': 'customer',
              'q[card_name_cont]': query
            }
          })
          .then(res => {
            this.$set(this.$data, 'customersList', res.data.users)
            this.customerLoading = false
          })
          .catch(err => {
            console.log(err)
            this.customerLoading = false
          })
        },
        700
      ),
      asyncFindStructures: _.debounce(
        function (query) {
          this.structuresLoading = true
          let url = RouteGen.index('structure')
          server.get(url, {
            params: {
              'q[card_name_cont]': query
            }
          })
          .then((res) => {
            this.$set(this.$data, 'structuresList', res.data.structures)
            this.structuresLoading = false
          })
          .catch(err => {
            console.log(err)
            this.structuresLoading = true
          })
        },
        700
      ),
      goToStructuresManagement () {
        this.$router.push({ name: 'Project objects management', params: { id: this.$route.params.id } })
      },
      saveGoToStructuresManagement () {
        this.submit(true)
      },
      submit (toPermissions = false) {
        this.$validator
          .validateAll()
          .then((result) => {
            if (result) {
              this.saveProject(this.$route.params.id, toPermissions)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      saveProject (id = null, toPermissions = false) {
        let url = RouteGen.create('project')
        let verb = 'post'
        let messageModifier = 'created'
        if (id) {
          url = RouteGen.edit('project', id)
          verb = 'patch'
          messageModifier = 'updated'
        }
        this.$data.project.customer_ids = this.getResourcesIds(this.$data.currentCustomers)
        this.$data.project.structure_ids = this.getResourcesIds(this.$data.currentStructures)
        server[verb](url, { project: this.$data.project })
          .then(res => {
            this.showNotification(201, messageModifier)
            if (toPermissions) {
              this.$router.push({ name: 'Project objects management', params: { id: res.data.project.id } })
            } else {
              this.$router.push({ name: 'All projects' })
            }
          })
          .catch(err => {
            this.showNotification(err.response.status)
          })
      },
      showNotification (status, modifier) {
        return this.getMessage(Messages.byStatus(status, 'Project', modifier))
      }
    },
    notifications: {
      getMessage: {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Project/Form.vue